import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptValDeMarne94 = () => {
  return (
    <DepartmentTemplate
      department="Val-de-Marne"
      departmentNumber="94"
      cities="Créteil, Vitry-sur-Seine, Champigny-sur-Marne, Saint-Maur-des-Fossés"
      region="Île-de-France"
    />
  );
};

export default DeptValDeMarne94;
